import { Accordion, AccordionDetails, AccordionSummary, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NodeImageUploader } from './nodeImageUploader';

export const ElementPropertyNodeImage = (props) => {

    return (
        <Accordion >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
            >
                <Typography>Image</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <NodeImageUploader node={props.node} projectId={props.projectId} updateImage={props.updateImage}/>
            </AccordionDetails>
        </Accordion>
    );
};